<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-symbols-rounded opacity-10 text-white" aria-hidden="true">groups</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">{{ $t('user.Users') }}</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-2">
                            </div>
                            <div class="col-lg-10">
                                <div class="d-flex justify-content-end align-items-center gap-2">
                                    <a :href="templateUrl" download class="download-link text-success">
                                        <i class="material-symbols-rounded">download</i>
                                        <span class="underline-text">Download Template</span>
                                    </a>
                                    
                                    <div class="btn-group" v-if="userRoleName == 'Admin'" style="margin-top: 15px;">
                                        <span class="btn btn-sm bg-gradient-success text-nowrap" style="width: 150px;">
                                            {{ $t('settings.Association') }}
                                        </span>
                                        <button type="button" class="btn btn-sm bg-gradient-success dropdown-toggle dropdown-toggle-split" data-bs-toggle="dropdown" aria-expanded="false">
                                            <span class="visually-hidden">{{ $t('settings.Select_association') }}</span>
                                        </button>

                                        <ul class="dropdown-menu dropdown-menu-end custom-association-dropdown">
                                            <li @click="associationId = ''">
                                                <span class="dropdown-item text-muted">{{ $t('settings.Select_association') }}</span>
                                            </li>
                                            <li><hr class="dropdown-divider" /></li>
                                            <li v-for="item in associations" :key="item.id" @click="associationId = item.id; associationName = item.abbreviation" class="dropdown-item">
                                            {{ item.abbreviation }}
                                            </li>
                                        </ul>
                                    </div>

                                    <label
                                        class="btn btn-sm btn-success m-0 d-flex align-items-center"
                                        :class="{ 'disabled-look': isUploading || !associationId }"
                                        :disabled="isUploading || !associationId"
                                        @mouseenter="hover = true"
                                        @mouseleave="hover = false"
                                        @click="startUpload"
                                        style="transition: background 0.3s ease;"
                                    >
                                        <i v-if="!isUploading" class="material-symbols-rounded text-white me-1" style="font-size: 16px;">upload</i>
                                        <div v-if="isUploading" class="spinner-border spinner-border-sm text-white me-1" role="status"></div>
                                        <span>{{ isUploading ? $t('eartag.Uploading') : $t('eartag.Upload_File') }}</span>
                                        <input type="file" accept=".xls,.xlsx" @change="handleFileUpload" hidden />
                                    </label>

                                    <div class="btn-group" v-if="userRoleName == 'AssociationAdmin'" style="margin-top: 15px !important;">
                                        <router-link
                                            :to="associationId ? { name: 'New User', params: { id: associationId } } : ''"
                                            class="btn btn-sm bg-gradient-success text-nowrap d-inline-flex align-items-center justify-content-center"
                                            :class="{ disabled: !associationId }"
                                            style="width: 165px;"
                                        >
                                            <i class="material-symbols-rounded text-white me-1" style="font-size: 16px; line-height:1;">add_2</i>{{ $t('user.Create_user') }}
                                        </router-link>
                                    </div>

                                    <div class="btn-group" v-if="userRoleName == 'Admin'" style="margin-top: 15px !important;">
                                        <router-link
                                            :to="associationId ? `/user/create/${associationId}` : '#'"
                                            class="btn btn-sm bg-gradient-success text-nowrap d-inline-flex align-items-center justify-content-center"
                                            :class="{ disabled: !associationId }"
                                            style="width: 165px;"
                                        >
                                            <i class="material-symbols-rounded text-white me-1" style="font-size: 16px; line-height:1;">add_2</i>{{ $t('user.Create_user') }}
                                        </router-link>
                                    </div>
                                </div>
                                
                                <div class="d-flex justify-content-end" v-if="userRoleName == 'Admin'">
                                    <span class="text-sm text-danger" v-if="!associationId">
                                        {{ $t('settings.Select_association_to_proceed') }}
                                    </span>
                                    <span class="text-sm text-success" v-if="associationId">
                                        {{ $t('settings.Association_selected') }}: {{ associationName }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="card-footer p-3" v-if="failedinserts && failedinserts.length > 0">
                        <div class="d-flex justify-content-between align-items-center">
                            <h6 class="mb-0">{{ $t('settings.Error_adding_the_following_users') }}</h6>                            
                            <button type="button" class="btn-danger" @click="closeFailedInserts" style="border: none; height: 25px; border-radius: 7px;"><i class="material-symbols-rounded">close</i></button>
                        </div>
                        <table id="usererror-list" class="table table-flush">
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold ms-5">{{ $t('settings.Email') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('settings.Error') }}</p></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in failedinserts" :key="user.email + user.errorMessage">
                                    <td>{{ user.email_required }}</td>
                                    <td>{{ user.errorMessage }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <hr class="dark horizontal my-0">
                    <div class="card-footer p-3">
                        <table ref="userTable" id="user-list" class="table table-flush">
                            <thead class="thead-light">
                                <tr>                                    
                                    <th><p class="mb-0 text-xs font-weight-bold ms-5">{{ $t('user.Name') }}</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">{{ $t('location.Address') }}</p></th>                                    
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="user in users" v-bind:key="user.id">
                                    <td>
                                        <div class="d-flex align-items-center">
                                            <div class="role-ribbon" :class="getRoleColorClass(user.roleName)"></div>
                                            <div class="avatar avatar-lg ms-3 me-3">  
                                                <!--img
                                                    :src="user.imageUrl"
                                                    alt="User Image"
                                                    class="shadow-sm rounded-circle"
                                                    @error="onImageError"
                                                /-->
                                                <img
                                                    :src="user.imageUrl || require('@/assets/no-image.png')"
                                                    alt="User Image"
                                                    class="shadow-sm rounded-circle"
                                                    @error="onImageError"
                                                />
                                            </div>
                                            <div class="text-left">
                                                <h6 class="mb-0 text-sm font-weight-normal">
                                                    {{ user.fullname }}
                                                </h6>
                                                <p class="text-xs text-secondary mb-0">{{ $t('user.Role') }}: {{ user.roleName }}</p>
                                                <p class="text-xs text-secondary mb-0">{{ $t('user.User_name') }}: {{ user.userName }}</p>
                                                <p class="text-xs text-secondary mb-0">{{ $t('user.E-mail') }}: {{ user.email }}</p>
                                                <p class="text-xs text-secondary mb-0"
                                                    v-if="userRoleName === 'Admin' && (user.roleName === 'Keeper' || user.roleName === 'AssociationAdmin')">
                                                    {{ $t('user.Association') }}: {{ user.associationName }}
                                                </p>
                                            </div>
                                        </div>
                                    </td>
                                    <td class="text-sm font-weight-normal" v-html="user.fullAddress"></td>
                                    <td>
                                        <div class="float-end">
                                            <button :data-id="user.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" :title="$t('common.Edit')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                            </button>
                                            <button :disabled="
                                                user.roleName === 'Admin' ||
                                                (user.roleName === 'Keeper' && user.canDelete === false) ||
                                                (user.roleName === 'Inspector' && user.canDelete === false) ||
                                                (user.roleName === 'AssociationAdmin' && user.canDelete === false)
                                                "
                                                :data-id="user.id" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" :title="$t('common.Delete')">
                                                <i class="material-symbols-rounded opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="row"></div>
    </div>        
</template>

<script>
import axios from 'axios'
//import loadingImageUrl from "@/assets/img/LoadingImage.gif";
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";

export default {
    name: 'User_index_page',
    components: {
    },
    computed: { 
        userRoleName() {
            return this.$store.state.user?.roleName;
        }
    },
    data() {
        return {
            templateUrl: "/templates/VeeBoek-importuser-template.xlsx",
            associationId: '',
            associationName: '',
            associations: [],
            searchFilter:'',
            roleFilter:'',
            users: [],
            gets: [],
            dataTableInstance: null,            
            isUploading: false,
            failedinserts: []
        }
    },
    async mounted() {
        await this.fetchUsers();
        await this.initializeUserTable();
        this.attachTableClickListener("#user-list", "Edit User");
    },
    methods: {
        onImageError(event) {            
            event.target.src = require('@/assets/no-image.png');
        },

        closeFailedInserts() {  
            this.failedinserts = null;
        },

        onAssociationChange() {
            // Clear ubn selection or other dependent state if needed
            //this.associationId = '';
        },

        // Called when user clicks the Upload button
        startUpload() {
            if (this.isUploading) return;

            if (!this.associationId) {
                // show the same validation as earlier
                this.$showError(this.$t('errors.Select_association_before_upload'));
                // optionally focus/select the association control:
                this.$nextTick(() => {
                    if (this.$refs.assocSelect) this.$refs.assocSelect.focus();
                });
                return;
            }

            // open the hidden file input
            if (this.$refs.fileInput) {
                this.$refs.fileInput.click();
            }
        },
        async handleFileUpload(event) {

            this.$store.commit('setShowLoading', true);

            const file = event.target.files[0];
            if (!file) {
                this.$showError('errors.No_file_selected_for_upload');
                this.$store.commit('setShowLoading', false);
                return;
            }

            if (!this.associationId) {
                this.$showError(this.$t('errors.Select_association_before_upload'));
                // clear file input so user can re-select
                if (this.$refs.fileInput) this.$refs.fileInput.value = '';
                else event.target.value = '';
                this.$store.commit('setShowLoading', false);
                return;
            }

            // Validate Excel file type
            const allowedTypes = [
                'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
                'application/vnd.ms-excel'                                           // .xls
            ];

            if (!allowedTypes.includes(file.type)) {
                this.$showError('errors.Only_excel_files_allowed');
                this.$store.commit('setShowLoading', false);
                return;
            }

            this.isUploading = true;
            const formData = new FormData();
            formData.append('file', file);
            formData.append('associationId', this.associationId);

            try {
                const response = await axios.post('auth/import', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });

                const result = response.data;

                if (result.success) {                    
                    this.$showSuccess(this.$t('errors.Success_users_uploaded_successfully'));
                    
                    if (Array.isArray(result.data)) {
                        this.failedinserts = result.data;                    
                    }

                    await this.fetchUsers();
                    await this.initializeUserTable();                    
                }
            } catch (error) {
                const errorMessage = error.response?.data?.message || error.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.isUploading = false;
                this.$store.commit('setShowLoading', false);

                if (this.$refs.fileInput) this.$refs.fileInput.value = '';
                else event.target.value = '';
            }
        },
        async fetchUsers() {
            try {
                this.$store.commit('setShowLoading', true);

                // If admin you also want associations loaded
                if (this.userRoleName === 'Admin') {
                    await this.fetchAllAssociationData();
                } else if (this.userRoleName === 'AssociationAdmin') {                    
                    this.associationId = this.$store.state.associationAdminAssociationId;
                }

                // build request url & params based on role
                let url = (this.userRoleName === 'AssociationAdmin') ? "User/getbyassociation" : "User/getall";
                const params = {
                    searchFilter: this.searchFilter || null,
                    roleFilter: this.roleFilter || null
                };
                if (this.userRoleName === 'AssociationAdmin') {
                    params.associationId = this.associationId;
                }

                const response = await axios.get(url, { params });
                this.gets = response?.data;

                if (!this.gets?.success) {
                    this.$showError('errors.Contact_system_admin');
                    this.users = [];
                    return;
                }

                // Map users and fetch images in parallel
                this.users = this.gets.data.userList.map(a => ({
                    ...a,
                    imageUrl: `${axios.defaults.baseURL}user/getprofileimage?aspNetUserId=${a.aspNetUserId}`,
                    loaded: false
                }));

                // load images without rerender loop
                //this.users.forEach(async (user) => {
                //    try {
                //        const imageUrl = await this.fetchUserImage(user.aspNetUserId);
                //        user.imageUrl = imageUrl;
                //    } catch {
                //        user.imageUrl = null;
                //    }
                //});
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            } finally {
                this.$store.commit('setShowLoading', false);
            }
        },
        async initializeUserTable() {

            // destroy existing instance
            if (this.dataTableInstance) {

                try {
                    this.dataTableInstance.destroy();
                } catch (e) {
                    console.log('could not destroy datatableinstance', e);
                }

                this.dataTableInstance = null;
            }

            await nextTick();

            // wait for paint
            await new Promise(requestAnimationFrame);

            const tableEl = this.$refs.userTable;

            if (!tableEl) {
                return;
            }

            this.dataTableInstance = new DataTable(tableEl, {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                paging: true,
                perPage: 10,
                //perPageSelect: [5, 10, 25, 50],
                sortable: true,

                labels: {
                    search: this.$t('datatable.Search'),
                    perPage: this.$t('datatable.PerPage'),
                    noRows: this.$t('datatable.NoRows'),
                    info: "Tonen {start} t/m {end} van {rows} items",
                    placeholder: this.$t('common.Search')
                },

                columns: [
                    { select: 0, sortable: true },
                    { select: 1, sortable: false },
                    { select: 2, sortable: false }
                ]
            });
        },        
        attachTableClickListener(selector, editRouteName) {
            document.querySelector(selector)?.addEventListener('click', (event) => {
                const targetElement = event.target.closest('[data-id]');
                if (!targetElement) return;

                const id = targetElement.getAttribute('data-id');
                if (!id) return;

                if (event.target.closest('.edit-button')) {
                    this.$router.push({ name: editRouteName, params: { id: id } });
                } else if (event.target.closest('.delete-button')) {
                    this.deleteUser(id);
                }
            });
        },
        async fetchAllAssociationData() {
            try {
                const response = await axios.get("association/getall");
                const result = response.data;

                if (result.success && Array.isArray(result.data.associationList)) {
                    this.associations = result.data.associationList;
                } else {
                    this.$showError('errors.Error_fetching_associations');                    
                }
            } catch (e) {                    
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }
        },
        getRoleColorClass(role) {
            switch (role) {
                case 'Admin':
                    return 'bg-admin';
                case 'AssociationAdmin':
                    return 'bg-associationadmin';
                case 'Inspector':
                    return 'bg-inspector';
                case 'Keeper':
                    return 'bg-keeper';                
                case 'OtherUser':
                    return 'bg-otheruser';
                default:
                    return 'bg-danger';
            }
        },
        async fetchUserImage(userId) {
            try {
                const response = await axios.get(`/user/getprofileimage`, {
                    params: { aspNetUserId: userId },
                    responseType: 'blob'
                });

                return URL.createObjectURL(response.data);
            } catch (error) {
                console.error('Error fetching user image:', error);
                return null;
            }
        },
        async deleteUser(id) {   
            this.$swal
                .fire({
                    text: this.$t('common.Are_you_sure_to_delete_this_record'),
                    //icon: "error",
                    cancelButtonText: this.$t('common.Cancel'),
                    confirmButtonText: this.$t('common.Confirm_Delete'),
                    showCancelButton: true,
                    position: 'top-end'
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {
                        // Put delete logic
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("user/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {                                
                                const response = await axios.get("User/getall" + this.searchFilter + '/' + this.roleFilter);
                                this.gets = response.data;                                

                                if (this.gets.success) {                                    
                                    this.users = this.gets.data.userList.map(a => ({
                                        ...a,
                                        imageUrl: null
                                    }));

                                    for (let user of this.users) {
                                        user.imageUrl = await this.fetchUserImage(user.aspNetUserId);
                                    }

                                    // Destroy the existing instance
                                    if (this.dataTableInstance) {
                                        this.dataTableInstance.destroy();
                                        this.dataTableInstance = null;
                                    }
                                    
                                    await nextTick(); // Wait for DOM update

                                    // Re-initialize the DataTable
                                    this.initializeUserTable();

                                    this.$showSuccess('errors.Success_record_is_deleted_successfully');                                    
                                } else {
                                    this.$showError('errors.Contact_system_admin');
                                }
                            } else {
                                this.$showError('errors.Contact_system_admin');
                            }
                        } catch (e) {
                            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
                        }
                        
                        this.$store.commit('setShowLoading', false);
                    }
                });            
        }
    }
}
</script>
<style scoped>    
    .download-link {
        display: inline-flex;
        align-items: center; /* vertically centers icon & text */
        gap: 4px;            /* spacing between icon and text */
        text-decoration: none; /* prevent underline on whole link */
    }
    .disabled-look {
        opacity: 0.65;
        pointer-events: none;
    }
    .underline-text {
        text-decoration: underline;
        text-underline-offset: 2px;
    }
    .assoc-vertical {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: flex-start;
        gap: 6px;
        margin-top: 15px;
    }
    .bg-admin {
        background-color: #7b809a !important;
    }

    .bg-associationadmin {
        background-color: #4caf50 !important;
    }

    .bg-otheruser {
        background-color: #f0f2f5 !important;
    }

    .bg-keeper {
        background-color: #1a73e8 !important;
    }

    .bg-inspector {
        background-color: #fb8c00 !important;
    }

    ::v-deep(.table tbody tr:hover) {
        background-color: #f0f2f5 !important;;
        color: #333 !important;;
        transition: background-color 0.2s ease-in-out !important;;
    }

    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }

    .font-size-14 {
        font-size: 14px !important;
    }

    .role-ribbon {
        width: 6px;
        height: 60px;
        border-radius: 4px;
    }
</style>